import React from "react";

const FormOrderOptions = ({
  orderOptions,
  setOrder,
  order,
  setParam,
  close,
}) => {
  return (
    <div>
      <div className="flex  flex-col">
        {orderOptions &&
          orderOptions.map((item, key) => (
            <div key={key} className={"flex py-1 items-center"}>
              <input
                id={"form_order_" + item.value}
                name="push-notifications"
                type="radio"
                onChange={() => {
                  setOrder(item.value);
                  const a = {};
                  a["order_by"] = item.value;
                  setParam(a);
                  close();
                }}
                checked={order == item.value}
                className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
              />
              <label
                htmlFor={"form_order_" + item.value}
                className="ml-3 block text-sm font-medium text-gray-700"
              >
                {item.label}
              </label>
            </div>
          ))}
      </div>
    </div>
  );
};

export default FormOrderOptions;
